import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

export class Testimonial {
    constructor(el) {
        this.el = el;

        this.slider = this.el.querySelector(".testimonials__slider");
        this.prev = this.el.querySelector(".testimonials__prev");
        this.next = this.el.querySelector(".testimonials__next");

        this.el && this.slider && this.init();
    }

    init() {
        this.splide = new Splide(this.slider, {
            type: "loop",
            drag: "free",
            focus: "center",
            arrows: false,
            pagination: false,
            autoWidth: true,
            autoScroll: {
                speed: 0.5,
            },
        }).mount({ AutoScroll });

        this.prev && this.prev.addEventListener("click", () => this.splide.go("<"));
        this.next && this.next.addEventListener("click", () => this.splide.go(">"));
    }

    destroy() {
        this.prev && this.prev.removeEventListener("click", () => this.splide.go("<"));
        this.next && this.next.removeEventListener("click", () => this.splide.go(">"));
    }
}

const testimonials = () => {
    const testimonials = document.querySelectorAll(".testimonials");

    testimonials &&
        !window.matchMedia("(prefers-reduced-motion: reduce)").matches &&
        testimonials.forEach(el => {
            new Testimonial(el);
        });
};

export default testimonials;
